( function () {
	/* globals angular */
	/* eslint no-use-before-define:0 */

	'use strict';
	/* @ngInject */
	function evidencePoolModal ( ) {
		var directive = {
			'templateUrl'  : '/templates/components/evidences/pool/evidence-pool-modal.html',
			'controller'   : 'evidencePoolModalController',
			'controllerAs' : 'vm',
			'scope'        : {
				// it is either observation data, group data, or indicator data
				'level'      : '=',
				'mode'       : '@',
				'filter'     : '=',
				'pool'       : '@',
				'group'      : '=',
				'innerLevel' : '=',
				'update'     : '&',

				// whole observation data
				'observation' : '=',
				'attached'    : '=',
				'isSplit'     : '=',
				'isObsLevel'  : '=',

				// if modal contains all evidences
				'hasAllEvidences'   : '=',
				'identifier'        : '@',
				'isTemplatePreview' : '='
			}
		};

		return directive;
	}

	angular
		.module( 'app.components' )
		.directive( 'evidencePoolModal', evidencePoolModal );
} )( );
